import React, { useEffect, useState } from 'react'
import util from 'meinian-package/src/utils/util'
import { BatchStop, BatchAllButton } from 'component/batch'
import BatchOptions from 'component/batch/options'
import { answer } from 'component/batch/base'
import { IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { BATCH_TYPE } from '../batchType'
import StyleBatchCheck from '../styleBatchCheck'
import StyleBatch from '../styleBatch'
import styles from './index.module.less'

// 暂时只在灵感集详情用到
export default ({ batchValue, batchAll, $masonry, info = {}, params, cancelBatch, auth, fileName }) => {
  const Component = {
    [BATCH_TYPE.audit]: (
      <StyleBatchCheck
        batchAll={batchAll}
        $masonry={$masonry}
        info={info}
        needMarkTimes={info.needMarkTimes}
        markStatus={params.markStatus ? +params.markStatus : 0}
        markTimes={params.markTimes ? +params.markTimes : 0}
        permissions={info?.loginUserInfo?.role}
        cancelBatch={cancelBatch}
      />
    ),
    [BATCH_TYPE.download]: <Download batchAll={batchAll} cancelBatch={cancelBatch} info={info} fileName={fileName} />,
    [BATCH_TYPE.export]: <Export batchAll={batchAll} cancelBatch={cancelBatch} info={info} fileName={fileName} />,
    [BATCH_TYPE.operation]: (
      <Operation batchAll={batchAll} cancelBatch={cancelBatch} $masonry={$masonry} info={info} auth={auth} />
    ),
  }
  return (
    Component?.[batchValue] || (
      <StyleBatch batchAll={batchAll} cancelBatch={cancelBatch} $masonry={$masonry} info={info} auth={auth} />
    )
  )
}

const Download = ({ cancelBatch, info, batchAll }) => {
  const [size, setSize] = useState(0)

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  return (
    <div className={styles['screen-wrap-item']}>
      <div>批量下载</div>
      <div className="screen-wrap-item-right">
        <div className="screen-wrap-item-right-item">
          已选择<span className="screen-wrap-item-right-num">{size}</span>个款式
        </div>
        <BatchAllButton
          style={{ marginRight: '8px' }}
          keyValues={batchAll.map((m) => `${m.imageGroupEntityId},${m.inspirationId}`)}
          infos={batchAll}
        />
        <BatchStop style={{ marginRight: '8px' }} onClick={() => cancelBatch()} />
        <div className="screen-wrap-item-right-item-line" />
        <BatchOptions.Download
          style={{ marginRight: '0', marginLeft: '8px' }}
          green
          hiddenFolderLevel
          fileName={info.name}
          onChange={() => {
            cancelBatch()
          }}
        />
      </div>
    </div>
  )
}

const Export = ({ cancelBatch, info, batchAll }) => {
  const [size, setSize] = useState(0)

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  return (
    <div className={styles['screen-wrap-item']}>
      <div>批量导出</div>
      <div className="screen-wrap-item-right">
        <div className="screen-wrap-item-right-item">
          已选择<span className="screen-wrap-item-right-num">{size}</span>个款式
        </div>
        <BatchAllButton
          style={{ marginRight: '8px' }}
          keyValues={batchAll.map((m) => `${m.imageGroupEntityId},${m.inspirationId}`)}
          infos={batchAll}
        />
        <BatchStop style={{ marginRight: '8px' }} onClick={() => cancelBatch()} />
        <div className="screen-wrap-item-right-item-line" />
        <BatchOptions.Export
          style={{ marginRight: '0', marginLeft: '8px' }}
          green
          fileName={info.name}
          onChange={() => {
            util.track('mn-statement-export', {
              module1: '批量导出',
              module2: '灵感集详情页',
            })
            cancelBatch()
          }}
        />
      </div>
    </div>
  )
}

const Operation = ({ batchAll, cancelBatch, $masonry, info }) => {
  const [size, setSize] = useState(0)

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])
  return (
    <div className={styles['screen-wrap-item']}>
      <div>批量操作</div>
      <div className="screen-wrap-item-right">
        <div className="screen-wrap-item-right-item">
          已选择<span className="screen-wrap-item-right-num">{size}</span>个款式
        </div>
        <BatchAllButton
          style={{ marginRight: '8px' }}
          keyValues={batchAll.map((m) => `${m.imageGroupEntityId},${m.inspirationId}`)}
          infos={batchAll}
        />
        <BatchStop style={{ marginRight: '8px' }} onClick={() => cancelBatch()} />
        <div className="screen-wrap-item-right-item-line" style={{ marginRight: '16px' }} />
        {info?.loginUserInfo?.role !== IDEA_MASS_ROLE.VIEWER && (
          <>
            <BatchOptions.Delete
              green
              onChange={() => {
                cancelBatch()
                $masonry.current?.init()
              }}
            />
            <BatchOptions.MoveImages
              green
              onChange={() => {
                cancelBatch()
                $masonry.current?.init()
              }}
              lajiInspirationId={info.id}
            />
          </>
        )}
        <BatchOptions.Collect
          green
          data={batchAll}
          onChange={() => {
            // cancelBatch(); $masonry.current?.init()
          }}
        />
      </div>
    </div>
  )
}
